export default {
  data() {
    return {
      isMousedown: false,
      isDragging: false,
      timeToPop: 250,
      spaceThreshold: 25,
      start: [],
      end: []
    };
  },
  methods: {
    handleMousedown(e) {
      this.setMousedown();
      this.doHandleInteractionStart(e);
    },
    handleMousemove(e) {
      this.doHandleInteractionMove(e);
    },
    handleMouseup(e) {
      this.doHandleInteractionEnd(e);
      this.setMouseup();
    },
    handleMouseout(e) {
      this.doHandleInteractionEnd(e);
      this.setMouseup();
    },
    handleClick(e) {
      this.doHandleInteractionStart(e);
      this.doHandleInteractionEnd(e);
    },
    handlePanstart(e) {
      this.setMousedown();
      this.doHandleInteractionStart(e.srcEvent);
    },
    handlePanmove(e) {
      this.doHandleInteractionMove(e.srcEvent);
    },
    handlePanend(e) {
      this.doHandleInteractionEnd(e.srcEvent);
      this.setMouseup();
    },
    handleTap(e) {
      if (e.preventDefault) e.preventDefault();
      else {
        this.doHandleInteractionStart(e.srcEvent);
        this.doHandleInteractionEnd(e.srcEvent);
      }
    },
    doHandleInteractionStart(e) {
      if(this.isMousedown)
        this.isDragging = true;
      if (this.isDuplicateEvent(e, "start")) {
        cancelEvent(e);
        return;
      } else this.logEvent(e, "start");
      if (this.handleInteractionStart(e))
        cancelEvent(e);
    },
    handleInteractionStart() {
      return false;
    },
    doHandleInteractionMove(e) {
      if(this.isMousedown)
        this.isDragging = true;
      this.handleHover(e);
      let cancelEvent;
      if (this.isMousedown && this.handleInteractionMove(e))
        cancelEvent(e);
    },
    handleInteractionMove() {
      return false;
    },
    handleHover() { },
    doHandleInteractionEnd(e) {
      if (this.isDuplicateEvent(e, "end")) {
        cancelEvent(e);
        return;
      } else this.logEvent(e, "end");
      if (this.handleInteractionEnd(e))
        cancelEvent(e);
    },
    handleInteractionEnd() {
      return false;
    },
    setMousedown() {
      this.isMousedown = true;
    },
    setMouseup() {
      this.isMousedown = false;
      this.isDragging = false;
    },
    isDuplicateEvent(e, key) {
      let set = this[key];
      if (!set.length) return false;

      let oldestEvent = set[0];
      return this.withinThreshold(e, oldestEvent);
    },
    withinThreshold(e1, e2) {
      return Math.abs(e1.offsetX - e2.offsetX) < this.spaceThreshold
        && Math.abs(e1.offsetY - e2.offsetY) < this.spaceThreshold;
    },
    logEvent(e, key) {
      let set = this[key];
      set.push(e);
      setTimeout(() => set.splice(0, 1), this.timeToPop);
    }
  }
};

function cancelEvent(e) {
  e.stopPropagation();
  e.preventDefault();
}